import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertModalService, ToastType } from './AlertModalService';

@Injectable({
  providedIn: 'root'
})
export class ResponseHandlerService {

  constructor(private alertModalService: AlertModalService) { }

  handleSuccess(message: string = 'Success'): void {
    this.alertModalService.showToast(message, ToastType.Success, 2000);
  }

  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      if (error.status !== 200 && error.error) {
        // Non-critical error with data
        this.alertModalService.showToast(error.error.message || 'An error occurred', ToastType.Warning, 5000, true);
      } else if (error.status !== 200) {
        // Critical error without data
        this.alertModalService.showToast(error.message || 'A critical error occurred', ToastType.Error, 10000, true);
        throw new Error(error.message || 'A critical error occurred');
      }
    } else {
      this.alertModalService.showToast('An unknown error occurred', ToastType.Error, 10000, true);
      throw new Error('An unknown error occurred');
    }
  }
}
